import { Component, Vue } from "vue-property-decorator";

@Component
export default class LoadingMixin extends Vue {
  protected isLoading = false;
  protected httpReturnedObj: object = {};

  get httpReturn() {
    return this.httpReturnedObj;
  }

  get loadingStatus() {
    return this.isLoading;
  }
}
